<template>
    <div
        id="cz3AppWrapper"
        class="app-height overflow-hidden relative bg-cloud-dark tracking-normal"
    >
        <product-renderer
            v-if="!isMobile"
            :class="{ 'hidden': isPersonalizeStep }"
            class="relative"
        />

        <div
            class="z-10 absolute top-0 w-full h-full flex flex-col text-black"
        >
            <the-header class="absolute top-0 z-20 md:relative" />

            <transition-group
                name="slide-fade"
                tag="div"
                class="relative grow overflow-hidden flex justify-center"
            >
                <customize-screen
                    v-if="isSelectStep"
                    class="h-full w-full max-w-screen-3xl overflow-hidden"
                />

                <personalize-screen
                    v-else-if="isPersonalizeStep"
                    class="h-full w-full overflow-hidden px-3.5 pt-16 md:p-6"
                />

                <review-screen
                    v-else-if="isReviewStep"
                    class="h-full w-full md:p-6"
                />
            </transition-group>

            <the-footer
                v-if="!isReviewStep && !isMobile"
                :class="{ 'bg-cloud-dark': currentStep === 'personalize'  || isReviewStep }"
            />

            <the-footer-mobile v-if="isMobile && !isReviewStep" />
        </div>
    </div>
</template>

<script>
    import * as constants from '../constants';
    import allStores from '../stores/all';

    import TheHeader from './TheHeader.vue';
    import ProductRenderer from './ProductRenderer.vue';
    import CustomizeScreen from './CustomizeScreen.vue';
    import PersonalizeScreen from './PersonalizeScreen.vue';
    import ReviewScreen from './ReviewScreen.vue';
    import TheFooter from './TheFooter.vue';
    import TheFooterMobile from './TheFooterMobile.vue';

    export default {
        mixins: [allStores],

        components: {
            TheHeader,
            ProductRenderer,
            CustomizeScreen,
            PersonalizeScreen,
            ReviewScreen,
            TheFooter,
            TheFooterMobile,
        },

        computed: {
            currentStep() {
                return this.appStore.currentStep;
            },

            isPersonalizeStep() {
                return this.currentStep === constants.STEP_PERSONALIZE;
            },

            isReviewStep() {
                return this.currentStep === constants.STEP_REVIEW;
            },

            isSelectStep() {
                return !this.isPersonalizeStep && !this.isReviewStep;
            },

            isMobile() {
                return this.appStore.isMobile;
            },
        },
    };
</script>
